import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";
import Inputs from "../../share/input/Inputs";
import MessageQuill from "../Message/MessageQuill";

function NewMessageModal({ close }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  return (
    <div className="AddnewsupportTicket relative">
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className=" text-center text-[#77498F] text-[16px] mb-16">
        پیام جدید{" "}
      </h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Name",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="عنوان پیام*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Email",
            },
          }}
          type="text"
          name="email"
          control={control}
          placeholder="دریافت کننده*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <MessageQuill placeholder="شرح پیام *" />
        <BtnPrimary
          className="py-[20px] px-[25px] flex mr-auto "
          text=" ثبت گروه"
        />
      </form>
    </div>
  );
}

export default NewMessageModal;
